import { Component, computed, input, output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { Tab } from '@ui';

@Component({
  selector: 'ui-vertical-tab',
  template: `
    <div
      class="px-6 from-transparent from-10% to-[#e6f7ff] cursor-pointer duration-300 transition-colors"
      [class]="stateClass().tab"
      (click)="emitTabClick()"
    >
      <div
        class="flex flex-row justify-between items-center"
        [class]="stateClass().label"
      >
        <div class="flex items-center gap-x-3 py-4 px-2 text-md">
          <ui-icon [icon]="icon()" class="text-2xl" />
          <span>{{ label() }}</span>
        </div>
        <span class="text-xl" [class]="stateClass().suffix" >
          {{ suffix() }}
        </span>
      </div>
    </div>
  `,
  imports: [IconComponent],
})
export class VerticalTabComponent {
  tab = input.required<Tab>();
  onTabClick = output<void>();

  label = computed(() => this.tab()?.label ?? '--')
  suffix = computed(() => this.tab()?.suffix ?? '--')
  icon = computed(() => this.tab()?.icon ?? null)
  active = computed(() => this.tab()?.active ?? false)

  stateClass = computed(() => this.getStateClass(this.active()));

  protected readonly DEFAULT_STATES = {
    default: {
      tab: 'text-neutral-7 hover:text-neutral-8',
      label: '',
      suffix: 'text-neutral-7',
    },
    active: {
      tab: 'text-error bg-gradient-to-r border-r-2 border-primary',
      label: '',
      suffix: 'text-error',
    },
  };

  emitTabClick() {
    this.onTabClick.emit();
  }

  private getState(active: boolean) {
    return active ? 'active' : 'default';
  }

  private getStateClass(active: boolean) {
    const classes = this.DEFAULT_STATES;
    const state = this.getState(active);
    return classes[state];
  }
}
